module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "wrap opti_wrap",
    class: {
      pd110: _vm.btnFixed
    },
    attrs: {
      "id": "app"
    }
  }, [_c('div', {
    staticClass: "loading-wrap",
    style: (_vm.togg())
  }, [_vm._m(0)]), _vm._v(" "), _c('div', {
    staticClass: "flow_top"
  }, [_c('div', {
    staticClass: "top-activity-rules__d",
    staticStyle: {
      "background": "rgb(255, 112, 0)",
      "color": "white"
    },
    on: {
      "click": _vm.jumpToActivity
    }
  }, [_vm._v("活动规则")]), _vm._v(" "), _c('img', {
    staticClass: "main-top",
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/theme_aqy/banner.jpg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    staticStyle: {
      "width": "20%",
      "position": "absolute",
      "top": "0.4rem",
      "left": "0.1rem",
      "animation": "2s ease 0s infinite normal none running zy",
      "transform-origin": "50% bottom"
    },
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/theme_aqy/ling.png",
      "alt": ""
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "scroll-container"
  }, [_c('div', {
    staticClass: "swiper-wrapper"
  }, _vm._l((_vm.getInfo), function(item) {
    return _c('div', {
      key: item,
      staticClass: "swiper-slide"
    }, [_c('div', {
      staticClass: "scroll-item"
    }, [_vm._v(" " + _vm._s(item) + " ")])])
  }), 0)]), _vm._v(" "), _c('div', {
    staticClass: "flow_top flow_input_bg"
  }, [_c('img', {
    staticClass: "main-top",
    attrs: {
      "src": _vm.mode == 1 || _vm.mode == 2 ? _vm.inputBgImgSrc1_2 : _vm.inputBgImgSrc,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "formElement1",
    class: {
      flow_select3: _vm.mode == 3, flow_select: _vm.mode == 0, flow_select1: _vm.mode == 1 || _vm.mode == 2
    }
  }, [(_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "formBox van-cell-group van-hairline--top-bottom"
  }, [_c('div', {
    staticClass: "form phone van-cell van-cell--required van-field"
  }, [_c('div', {
    staticClass: "van-cell__value van-cell__value--alone van-field__value"
  }, [_c('div', {
    staticClass: "van-field__body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phonenum),
      expression: "phonenum"
    }],
    staticClass: "van-field__control",
    attrs: {
      "type": "tel",
      "id": "inputPhone",
      "placeholder": "请输入你的手机号"
    },
    domProps: {
      "value": (_vm.phonenum)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phonenum = $event.target.value
      }
    }
  })])])])]) : _vm._e(), _vm._v(" "), (_vm.mode == 3) ? _c('div', {
    staticClass: "formBox formBoxPhone van-cell-group van-hairline--top-bottom"
  }, [_c('div', {
    staticClass: "form phone van-cell van-cell--required van-field"
  }, [_c('div', {
    staticClass: "van-cell__value van-cell__value--alone van-field__value"
  }, [_c('div', {
    staticClass: "van-field__body"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.captcha),
      expression: "captcha"
    }],
    staticClass: "van-field__control",
    attrs: {
      "type": "number",
      "inputmode": "decimal",
      "placeholder": "请输入验证码"
    },
    domProps: {
      "value": (_vm.captcha)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.captcha = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.timesCount === 0) ? _c('div', {
    staticClass: "van-field__button",
    on: {
      "click": _vm.bindOpen
    }
  }, [_vm._m(1)]) : _c('div', {
    staticClass: "van-field__button"
  }, [_c('div', {
    staticStyle: {
      "color": "rgb(240, 169, 25)",
      "font-size": "0.28rem",
      "height": "1.1rem",
      "line-height": "1.1rem"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.2rem",
      "position": "relative",
      "top": "-0.02rem"
    }
  }, [_vm._v("|")]), _vm._v(_vm._s(_vm.timesCount) + "\n                                ")])])])])])]) : _vm._e(), _vm._v(" "), (_vm.mode == 1 || _vm.mode == 2) ? _c('div', {
    attrs: {
      "id": "cap"
    }
  }, [_c('iframe', {
    attrs: {
      "width": "100%",
      "scrolling": "no",
      "id": "frame",
      "name": "frame",
      "src": _vm.capUrl,
      "frameborder": "0"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "btn_box"
  }, [_c('img', {
    staticClass: "btn_img",
    class: {
      fixed: _vm.btnFixed
    },
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/theme_aqy/get_btn.png"
    },
    on: {
      "click": _vm.bindOpen
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "agree"
  }, [(!_vm.checked) ? _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/common/unchecked_yellow.png"
    },
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }) : _c('img', {
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/common/checked_yellow.png"
    },
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }), _vm._v(" "), _c('span', [_c('span', {
    on: {
      "click": function($event) {
        _vm.checked = !_vm.checked
      }
    }
  }, [_vm._v("我已详细阅读并同意")]), _vm._v(" "), _vm._m(2), _vm._v("、\n                    "), _vm._m(3), _vm._v("\n                    及相关条款\n                ")])]) : _vm._e(), _vm._v(" "), (_vm.mode == 0 || _vm.mode == 3) ? _c('div', {
    staticClass: "product-info"
  }, [_c('p', [_vm._v("开通联合会员，领热门会员+话费")]), _vm._v(" "), _c('p', [_vm._v("业务资费：6元起/月")]), _vm._v(" "), _vm._m(4)]) : _vm._e()])]), _vm._v(" "), (_vm.isGdt) ? _c('div', {
    staticClass: "ftxs_main"
  }, [_c('img', {
    staticClass: "benefit-bg",
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/h5/common/bottom.jpg"
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.channelid == '1020526004') ? _c('div', {
    staticClass: "product-info1"
  }, [_c('p', [_vm._v("公司名称：湖南锋芒传媒有限公司")]), _vm._v(" "), _c('p', [_vm._v("地址：长沙市雨花区井湾子街道井莲路397号紫铭大厦2610")]), _vm._v(" "), _vm._m(5)]) : _vm._e(), _vm._v(" "), _c('qs-quit-box', {
    attrs: {
      "showQuitModal": _vm.showQuitModal,
      "channelId": _vm.channelid,
      "phone": _vm.phonenum,
      "tuiaId": _vm.advertId
    },
    on: {
      "closeQuitModal": _vm.closeQuitModal
    }
  }), _vm._v(" "), _c('page-close-mask', {
    attrs: {
      "showMask": _vm.pageClose
    }
  }), _vm._v(" "), _c('iframe', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "width": "100%",
      "scrolling": "no",
      "src": _vm.productUrl
    }
  })], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "loading-box"
  }, [_c('img', {
    staticStyle: {
      "width": "120px",
      "border-radius": "10px",
      "padding-left": "0px"
    },
    attrs: {
      "src": "https://resource.0168.net.cn/activity-mall/images/loading-img.gif"
    }
  }), _vm._v(" "), _c('div', {
    staticStyle: {
      "width": "100%",
      "color": "white",
      "padding": "10px 6px"
    }
  }, [_vm._v("稍等片刻~")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticStyle: {
      "color": "rgb(240, 169, 25)",
      "font-size": "0.28rem",
      "height": "1.1rem",
      "line-height": "1.1rem"
    },
    attrs: {
      "size": "small",
      "type": "primary"
    }
  }, [_c('span', {
    staticStyle: {
      "margin-right": "0.2rem",
      "position": "relative",
      "top": "-0.02rem"
    }
  }, [_vm._v("|")]), _vm._v("获取验证码\n                                ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://store.0168.net.cn/activity-mall/h5/indexaqy_activity.html"
    }
  }, [_c('u', [_vm._v("活动规则")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    attrs: {
      "href": "https://store.0168.net.cn/activity-mall/privacy/content.html"
    }
  }, [_c('u', [_vm._v("用户隐私协议")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("客服电话："), _c('a', {
    attrs: {
      "href": "tel:4008008663"
    }
  }, [_vm._v("4008008663")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_vm._v("联系电话："), _c('a', {
    attrs: {
      "href": "tel:13024568854"
    }
  }, [_vm._v("13024568854")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-069492fa!./~/vue-loader/lib/selector.js?type=template&index=0!./src/h5/themeaqy/ThemeAqy.vue
// module id = 904
// module chunks = 24